module.exports = __webpack_public_path__ + "static/media/KH.72c948be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/KH.svg
// module id = 2184
// module chunks = 7